import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'newlineToBr'
})
export class NewlineToBrPipe implements PipeTransform {

  transform(value: string | null | undefined, ...args: unknown[]): unknown {
    if (!value) return '';
    return value.replace(/\n/g, '<br>');
  }

}
